/*
 * Public API Surface of ngx-mat-menu
 */

export * from './lib/interfaces/menu-models';
export * from './lib/ngx-mat-menu.service';
export * from './lib/ngx-mat-menu.component';
export * from './lib/ngx-mat-menu.module';
